import { Card } from "@/components/Card/card";
import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";

type Props = {
  stepName: string;
  className?: string;
};

const AddStepperStepTitleCard = ({ stepName, className }: Props) => {
  return (
    <Card className={cn("w-full gap-6 px-6 py-4", className)}>
      <div>
        <Text variant="h4">{stepName}</Text>
      </div>
    </Card>
  );
};

export default AddStepperStepTitleCard;
